import { Component, HostListener, ViewChild, OnInit } from "@angular/core";

import * as _ from "lodash";

import { DialogContentComponent } from "../../../../dialog/dialog.base.module";
import {
  Dialog,
  DialogRef,
  DialogParams
} from "../../../../dialog/dialog.base";
import { FormSchema } from "../../../../form";

/**
 * @ignore
 */
@Component({
  selector: "uex-input-select-multiple-modal",
  templateUrl: "./multiple.modal.html",
  host: {
    class: "uex-input-select-multiple-modal"
  }
})
export class InputSelectMultipleModal implements OnInit {
  @ViewChild(DialogContentComponent, { static: true }) content: DialogContentComponent;

  constructor(
    private _dialogRef: DialogRef,
    private _dialogParams: DialogParams
  ) {}

  private _dialog: Dialog;
  private _value: Array<any>;

  public schema: FormSchema;
  public formatted_options: Array<any>;

  public activeIndex: number;

  @HostListener("document:keydown", ["$event"]) onKeydown(e: KeyboardEvent) {
    const keyCode = e.which || e.keyCode;
    switch (keyCode) {
      case 38: // Arrow up
        event.preventDefault();
        this.decreaseActiveIndex();
        break;
      case 9: // Tab
        event.preventDefault();
        if (e.shiftKey) {
          this.decreaseActiveIndex();
        } else {
          this.increaseActiveIndex();
        }
        break;
      case 40: // Arrow down
        event.preventDefault();
        this.increaseActiveIndex();
        break;
      case 13: // Return
        event.preventDefault();
        this.select();
        break;
      case 32: // Space
        event.preventDefault();
        this.selectActive();
        break;
      default:
        return;
    }
  }

  public ngOnInit() {
    this._dialog = this._dialogRef.dialog;
    this.schema = this._dialogParams.get("schema");
    this._value = this.schema.value || [];
    this.formatted_options = this.schema.formatted_options.map(option => {
      option.checked =
        _.findIndex(this._value, item => _.isEqual(item, option.value)) > -1
          ? true
          : false;
      return option;
    });
  }

  public toggleOption(option) {
    option.checked = option.checked ? false : true;
    this.activeIndex = null;
  }

  public close() {
    this._dialog.close();
  }

  public select() {
    this._dialog.returnValue(
      this.formatted_options
        .filter(option => option.checked)
        .map(option => option.value)
    );
  }

  public isActive(index: number): boolean {
    return this.activeIndex == index;
  }

  private selectActive() {
    if (
      _.isNumber(this.activeIndex) &&
      this.formatted_options[this.activeIndex]
    ) {
      const options = this.formatted_options[this.activeIndex];
      options.checked = !!!options.checked;
    }
  }

  private decreaseActiveIndex() {
    if (this.formatted_options.length == 0) {
      return;
    }
    let index = this.activeIndex;
    if (_.isNumber(this.activeIndex)) {
      if (index > 0) {
        index--;
      } else {
        index = null;
      }
    } else {
      index = this.formatted_options.length - 1;
    }
    this.ajustScroll(index);
    this.activeIndex = index;
  }

  private increaseActiveIndex() {
    if (this.formatted_options.length == 0) {
      return;
    }
    let index = this.activeIndex;
    if (_.isNumber(index)) {
      if (index < this.formatted_options.length - 1) {
        index++;
      } else {
        index = null;
      }
    } else {
      index = 0;
    }
    this.ajustScroll(index);
    this.activeIndex = index;
  }

  private ajustScroll(index: number = this.activeIndex) {
    if (this.formatted_options.length == 0 || !_.isNumber(index)) {
      return;
    }
    const content = this.content.elementRef.nativeElement;
    const options = content.getElementsByClassName("uex-list-item");

    const content_scroll_top = content.scrollTop;
    const content_height = content.clientHeight;

    const selected_top = options[index].offsetTop;
    const selected_bottom = selected_top + options[index].clientHeight;

    if (content_scroll_top > selected_top) {
      content.scrollTop = selected_top;
    } else if (content_scroll_top + content_height < selected_bottom) {
      content.scrollTop = selected_bottom - content_height;
    }
  }
}
